import { PROJECT_CONTENT_TAB_TYPE, ProjectContentData } from '../types';
import { tableOfContentTab } from './data';

export const sqrpSale: ProjectContentData = {
  id: 'sqrp-sale',
  tabs: [
    {
      id: 'description',
      label: 'Description',
      type: PROJECT_CONTENT_TAB_TYPE.TABLE_OF_CONTENT,
      content: tableOfContentTab,
    },
    {
      id: 'key-metrics',
      label: 'Key Metrics',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'bep20',
          value: 'BEP20',
          name: 'Blockchain Network',
          description: (
            <span>
              Indicates the blockchain
              <br />
              network for this token.
            </span>
          ),
        },
        {
          id: 'total-supply',
          value: '1.000.000.000',
          name: 'Total Supply',
          description: <span>Displays the total token supply.</span>,
        },
        {
          id: 'initial-circulation-supply',
          value: '43.587.597',
          name: 'Initial Circulating Supply',
          description: (
            <span>
              Shows the circulating supply at the
              <br />
              Token Generation Event (TGE).
            </span>
          ),
        },
        {
          id: 'initial-market-cap',
          value: '523.051',
          name: 'Initial Market Cap',
          description: (
            <span>
              Reflects the initial
              <br />
              market cap at the TGE.
            </span>
          ),
        },
      ],
    },
    {
      id: 'deal-terms',
      label: 'Deal Terms',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'total-raising-goal',
          name: 'Total Raising Goal',
          value: '$15,000',
          description: (
            <span>
              Total funds targeted to be
              <br />
              raised across all pools in this IDO.
            </span>
          ),
        },
        {
          id: 'ido-price',
          name: 'IDO Price',
          value: '$0.36',
          description: (
            <span>
              Price per token
              <br />
              during the IDO.
            </span>
          ),
        },
        {
          id: 'allocation-size',
          name: 'Allocation Size',
          value: '$1-15',
          description: (
            <span>
              Range of allocation
              <br />
              sizes for participants.
            </span>
          ),
        },
        {
          id: 'accepted-payment',
          name: 'Accepted Payment',
          value: 'USDT (BEP20)',
          description: (
            <span>
              Accepted stable coin and network
              <br />
              for IDO participation.
            </span>
          ),
        },
      ],
    },
    {
      id: 'vesting',
      label: 'Vesting',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      layout: 3,
      content: [
        {
          id: 'first-unlock',
          value: '50 %',
          name: 'First unlock',
          description: (
            <span>
              Percentage of tokens
              <br />
              claimable at the vesting start
            </span>
          ),
        },
        {
          id: 'next-unlocks',
          value: '25 % daily',
          name: 'Next unlocks',
          description: (
            <span>
              Percentage and period of
              <br />
              next unlocks.
            </span>
          ),
        },
        {
          id: 'distribution-method',
          value: 'Magic Launchpad claiming contract',
          name: 'Distribution Method',
          description: (
            <span>
              Information on token
              <br />
              distribution/claim process.
            </span>
          ),
        },
      ],
    },
    {
      id: 'ido',
      label: 'IDO Schedule',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'sale-start',
          value: 'TBD',
          name: 'Sale Start',
          description: <span>Start date of the IDO.</span>,
        },
        {
          id: 'sale-end',
          value: 'TBD',
          name: 'Sale End',
          description: <span>End date of the IDO.</span>,
        },
        {
          id: 'tge-date',
          name: 'TGE Date',
          value: 'TBD',
          description: (
            <span>
              Estimated date
              <br />
              of the token's TGE.
            </span>
          ),
        },
        {
          id: 'token-distribution-start',
          name: 'Token Distribution Start',
          value: 'TBD',
          description: (
            <span>
              Date of the first token
              <br />
              claim/distribution post-TGE.
            </span>
          ),
        },
      ],
    },
  ],
};
